import React, {useEffect} from 'react';
import {useNavigate} from "react-router-dom";
import FileTable from "./FileTable";

function Home() {
    const navigate = useNavigate();

    useEffect(() => {
        navigate("/storage/root");
    }, []);

}

export default Home;